module.exports = __webpack_public_path__ + "img/timebinder-icon-menu-logo.49141f02.svg";